import { Navigate, Outlet, useLocation } from 'react-router';
import { Spinner } from '../components/Spinner';
import { useAuth } from './context';

/** Layout guard for every signed-in route. */
export function RequireAuth() {
  const { status } = useAuth();
  const location = useLocation();
  if (status === 'initializing') {
    return (
      <div className="full-center">
        <Spinner />
      </div>
    );
  }
  if (status === 'signedOut') {
    // Carry where they were headed: the handbook lives behind this guard now,
    // and a shared article link that dumps you on the home screen after signing
    // in is a link that didn't work.
    return (
      <Navigate
        to="/signin"
        replace
        state={{ from: location.pathname + location.search + location.hash }}
      />
    );
  }
  return <Outlet />;
}
